import map from "lodash/map"

export class GetSectionDetailResponse {
  constructor(responseJSON) {
    this.responseJSON = responseJSON;
  }

  getSectionName() {
    return this.responseJSON["sectionNumber"];
  }

  getSectionId() {
    return this.responseJSON["sectionId"];
  }

  getHousingId() {
    return this.responseJSON["housingId"];
  }

  getHousingName() {
    return this.responseJSON["housingName"];
  }

  getHousingCode() {
    return this.responseJSON["housingCode"];
  }

  getSectionAzimuth() {
    let azimuth = this.responseJSON["housingAzimuth"];
    if (parseInt(azimuth) < 0 || parseInt(azimuth) > 360 || azimuth == null || isNaN(azimuth))
      azimuth = 0;
    return parseInt(azimuth);
  }

  getHousingDescription() {
    return this.responseJSON["housingDescription"];
  }

  getFinishedStatus() {
    let finishedStatus = this.responseJSON["sectionFinished"];
    if ( !finishedStatus ) {
      return '';
    } else {
      return finishedStatus;
    }
  }

  getSectionImage() {
    return this.responseJSON["housingImage"];
  }

  getSectionViewBox() {
    return this.responseJSON["viewBox"];
  }

  getSectionPrev() {
    let prev = this.responseJSON["prevId"],
      sections = this.responseJSON["sections"],
      sectionsCount = sections.length;

    if (prev === null) {
      prev = sections[sectionsCount - 1].id;
    }

    return prev;
  }

  getSectionNext() {
    let next = this.responseJSON["nextId"],
      sections = this.responseJSON["sections"];

    if (next === null) {
      next = sections[0].id;
    }

    return next;
  }

  /**
   * @returns {SectionFloor[]}
   */
  getSectionsCoordinates() {
    return map(this.responseJSON["sections"], (sectionsJSON) => {
      return new HousingSection(sectionsJSON);
    });
  }

  /**
   * @returns {SectionFloor[]}
   */
  getSectionsFloors() {
    return map(this.responseJSON["floors"], (floorJSON) => {
      return new SectionFloor(floorJSON);
    });
  }

    getConsultation() {
        return this.responseJSON['getConsultation'];
    }
}



class HousingSection {
  constructor(sectionsJSON) {
    this.sectionsJSON = sectionsJSON;
  }

  getId() {
    return this.sectionsJSON["id"];
  }

  getNumber() {
    return this.sectionsJSON["number"];
  }

  getCoordinates() {
    return this.sectionsJSON["coordinates"];
  }

}



class SectionFloorFlat {
  constructor(flatJSON) {
    this.flatJSON = flatJSON;
  }

  getId() {
    return this.flatJSON["id"];
  }

  getType() {
    return this.flatJSON["type"];
  }

  getFloor() {
    return this.flatJSON["floor"];
  }

  getAccess() {
    return this.flatJSON["access"];
  }

  getPrice() {
      if (parseInt(this.flatJSON["price"]) === 0) {
          return false;
      }
    return this.flatJSON["price"];
  }

  getArea() {
    return this.flatJSON["area"];
  }
}



class SectionFloor {
  constructor(floorJSON) {
    this.floorJSON = floorJSON;
  }

  /**
   * @returns {SectionFloorFlat[]}
   */
  getFlats() {
    return map(this.floorJSON["apartments"], (apartmentJSON) => {
      return new SectionFloorFlat(apartmentJSON);
    });
  }

  getId() {
    return this.floorJSON["id"];
  }

  getNumber() {
    return this.floorJSON["number"];
  }

  getAccessFloorFlats() {
    let floorsFlats = this.floorJSON["apartments"],
      floorsFlatsCount = floorsFlats.length,
      floorAccess = false;

    for (var i = 0; i < floorsFlatsCount; i++) {
      let stateAccess = floorsFlats[i].access;
      if (stateAccess) {
        floorAccess = true;
        break;
      }
    }

    return floorAccess;
  }
}


// WEBPACK FOOTER //
// ./js/api/GetSectionDetailResponse.js